import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { translate } from '@smovilgps/optimus-intl';
import { Form, Select } from 'antd-v6';
import PropTypes from 'prop-types';

const FormItem = Form.Item;
const Option = Select.Option;

const EventForm = ({ form, events, handleEventChange, eventTargetKeys }) => {
	const intl = useIntl();
	const [activeTargetKeys, setActiveTargetKeys] = useState([]);

	const eventOptions = events.map(
		(event) =>
			event.active && (
				<Option key={`event-${event.id}`} value={event.id} disabled={!event.active}>
					{event.name}
				</Option>
			)
	);

	useEffect(() => {
		setActiveTargetKeys(
			eventTargetKeys.filter((tk) => {
				const matchingEvent = events.find((event) => event.id === tk && event.active === true);
				return matchingEvent !== undefined;
			})
		);
	}, [eventTargetKeys]);

	return (
		<Form
			form={form}
			className="login-form col-8"
			layout={'vertical'}
			data-testid="event-form"
			preserve={false}
			fields={[{ name: 'id', value: activeTargetKeys }]}
		>
			<FormItem name="id" initialValue={activeTargetKeys}>
				<Select
					allowClear
					style={{ width: '100%' }}
					mode="multiple"
					placeholder={intl.formatMessage(translate('selectEvents'))}
					className="eventSelect"
					data-testid="select-events"
					filterOption={(input, option) => option.children.toLowerCase().includes(input.trim().toLowerCase())}
					onChange={handleEventChange}
				>
					{eventOptions}
				</Select>
			</FormItem>
		</Form>
	);
};

EventForm.propTypes = {
	form: PropTypes.object,
	events: PropTypes.array.isRequired,
	eventTargetKeys: PropTypes.array.isRequired,
	handleEventChange: PropTypes.func,
};

export default EventForm;
